import React from "react";

function QuestionEditText(props) {
    const hideErrorCSS = props.questionValid || (typeof props.value !== "undefined" && props.value !== "");

    return (
        <div className={"error_container error_container--textarea " + (hideErrorCSS ? "" : "error_container--active")}>
            <textarea id={props.id}
                      className="questionaire__builder__question__inputs__textarea"
                      value={props.value}
                      onChange={props.onChange}
                      maxLength={5000}
                      name=""
                      cols="30"
                      rows="2"/>
            <span className="error_container__message">{props.errorMessage}</span>
        </div>);
}

export default QuestionEditText;